Jr = (function (my) {
    const me = my.dataTable = {};

    me.init = function () {
        //
    };

    me.options = {
        classes: 'table table-hover table-condensed',
        clickToSelect: false,
        contentType: 'application/x-www-form-urlencoded',
        maintainSelected: false,
        method: 'GET',
        onSort(orderBy, sortOrder) {
            // when sorting, grey out the table contents until the results are back
            $('#report-results-table').addClass('sorting');
            $('body').css('cursor', 'progress');
        },
        pageSize: 20,
        pagination: false,
        queryParamsType: 'limit',
        queryParams(params) {
            return params;
        },
        responseHandler(res) {
            return {
                total: res.meta.total,
                rows: res.data,
                duration: res.meta.duration,
            };
        },
        search: false,
        showColumns: false,
        showPaginationSwitch: false,
        showRefresh: false,
        showToggle: false,
        sidePagination: 'server',
        striped: true,
        toolbar: null,
    };

    return my;
}(Jr || {}));

Jr = (function (my) {
    const me = my.reportsDataTable = {};

    me.options = _.extend({}, Jr.dataTable.options, {
        formatNoMatches() {
            return 'No users to show';
        },
        contentType: 'application/x-www-form-urlencoded',
        classes: 'table table-hover table-condensed',
        height: window.innerHeight * 0.85,
        striped: true,
        showRefresh: true,
        showToggle: false,
        showColumns: true,
        showPaginationSwitch: false,
        minimumCountColumns: '2',
        pagination: true,
        search: false,
        toolbarAlign: 'right',
        searchAlign: 'left',
        clickToSelect: true,
        maintainSelected: false,
        sidePagination: 'server',
        pageSize: 25,

        onLoadSuccess(data) {
            const reportResultsTable = $('#report-results-table');
            $('time.timeago').timeago();
            reportResultsTable.removeClass('sorting');
            reportResultsTable
                .closest('.bootstrap-table')
                .find('.pagination-detail .duration')
                .remove();
            reportResultsTable
                .closest('.bootstrap-table')
                .find('.pagination-detail')
                .append(
                    `<span class="duration">&nbsp;&nbsp;&nbsp;<em>(query took ${
                        data.duration.toFixed(4)
                    } seconds)</em></span>`,
                );

            $('body').css('cursor', 'default');
            $('.app').removeClass('light-blur');
            $('#ajax-progress-indicator').fadeOut();
        },
        onSort() {
            // when sorting, grey out the table contents until the results are back
            $('#report-results-table').addClass('sorting');
            $('body').css('cursor', 'progress');
        },
        onColumnSwitch(field, checked) {
            if ($('#search-date option:selected').val() == 'custom') {
                $('#report-results-table th.date-range-header').text(
                    `${$('#search-start-date').val()} to ${$('#search-end-date').val()}`,
                );
            } else {
                $('#report-results-table th.date-range-header').text(
                    $('#search-date option:selected').text(),
                );
            }
        },
    });

    return my;
}(Jr || {}));
